import AudioManager from "../../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class NewClass extends cc.Component {
    @property(cc.SpriteFrame)
    sp1: cc.SpriteFrame = null;
    @property(cc.SpriteFrame)
    sp2: cc.SpriteFrame = null;
    @property(cc.Label)
    label: cc.Label = null;

    @property(cc.Node)
    content: cc.Node = null;


    start () {

    }
    changeRdata(rdata){
        let arr = [];
        for (let key in rdata){
            let item = rdata[key];
            for (let i = 0;i < item.length;i++){
                arr.push(item[i]);
            }
        }
        return arr;
    }
    updateUI(rdata){
        rdata = this.changeRdata(rdata);
        if (this.content.children.length > rdata.length){
            for (let i = rdata.length; i < this.content.children.length;i++){
                this.content.children[i].active = false;
            }
        }
        let item = null;
        for (let i = 0; i < rdata.length;i++){
            if(this.content.children.length > i){
                item = this.content.children[i];
            }
            else
                item = cc.instantiate(this.content.children[0]);
            let scope = rdata[i].wcMoneyScope.split(",");
            item.getChildByName("bg").getComponent(cc.Sprite).spriteFrame = (i % 2 === 0 ? this.sp1 : this.sp2);
            item.getChildByName("labRank").getComponent(cc.Label).string = scope[0] + "-" + scope[1];
            item.getChildByName("labVip").getComponent(cc.Label).string = rdata[i].vipId;
            item.getChildByName("labMoney").getComponent(cc.Label).string = rdata[i].wcPercent + "%";
            item.parent = this.content;
            item.active = true;
        }
    }

    onBtnClose(event,param){
        AudioManager.playSound("close");
        this.node.active = false;
    }
}
